const zoomCoefficient = 0.3;
const ratio = 1.4142;
const mobileBreakpoints = 768;
const mobilePadding = 80;
const desktopPadding = 165;
const mapFormatMapping = {
    A1: {
        formatHeight: '84cm',
        formatWidth: '59,4cm',
        price: '45',
        format: 'A1',
        formatCoefficient: 1
    },
    A2: {
        formatHeight: '59,4cm',
        formatWidth: '42cm',
        price: '36',
        format: 'A2',
        formatCoefficient: 0.95
    },
    A3: {
        formatHeight: '42cm',
        formatWidth: '29,7cm',
        price: '29',
        format: 'A3',
        formatCoefficient: 0.9
    }
};

class MapSizeControl {

    constructor(editor){
        this.editor = editor;
    }

    init(){
        const formatData = this.getFormatData(yourMap.size);
        this.setupDomSettings();
        this.setFormatInformationInDOM(formatData);
        this.adjustMapSize();
    }

    getFormatData(mapSize){
        return mapFormatMapping[mapSize];
    }

    setupDomSettings(){
        this.mapDom = {
            map: document.getElementById('map'),
            canvas: document.querySelector('.canvas'),
        };
        this.mapWidth = parseFloat(window.getComputedStyle(this.mapDom.map).width);
    }

    setFormatInformationInDOM(formatData) {
        let formatRadio = $(`#${formatData.format}`);
        formatRadio.prop('checked', true);
        $('.right-dimension span').text(formatData.formatHeight);
        $('.bottom-dimension span').text(formatData.formatWidth);
        //TODO move price to proper place
        $('.js-add-to-cart-btn .text-checkout .price').text(formatData.price);
    }

    adjustMapSize(){
        const formatData = this.getFormatData(yourMap.size);
        this.adjustFrameSize(formatData.formatCoefficient);
        this.adjustCanvasSize();
    }

    adjustFrameSize(formatCoefficient){
        const style = window.getComputedStyle(document.getElementById('map-holder'));

        const smallerDimension = style.width > style.height ? style.height : parseInt(style.width) * ratio;
        const frameSize = this.getFrameSize(smallerDimension, style.height, formatCoefficient);
        $('.js-map').css(frameSize);

    }

    getFrameSize(smallerDimension, mapHolderHeight, formatCoefficient){
        const padding = window.innerWidth >= mobileBreakpoints ? desktopPadding : mobilePadding;
        const height = parseInt(smallerDimension) * formatCoefficient - padding;
        const maxHeight = parseInt(mapHolderHeight)* formatCoefficient - padding;

        return {
            'height': `${height}px`,
            'width': `${height/ratio}px`,
            'max-height':`${maxHeight}px`,
            'max-width': `${maxHeight/ratio}px`
        };
    }

    adjustCanvasSize(){
        const canvasWidth = parseFloat(window.getComputedStyle(this.mapDom.canvas).width);
        this.mapDom.map.style.transform = `scale(${canvasWidth/this.mapWidth})`;
    }

    changeMapSize(formant){
        const formatData = this.getFormatData(formant);
        this.changeZoomRelativeToFormat(formatData.format);
        updateYourMapObject({size: formatData.format});
        this.setFormatInformationInDOM(formatData);
        this.adjustMapSize(formatData.formatCoefficient);
    }

    changeZoomRelativeToFormat(format){
        const scaleDifference = Math.abs(yourMap.size.match(/\d+/) - format.match(/\d+/)) * zoomCoefficient;
        const newZoom = format > yourMap.size ? yourMap.zoom + scaleDifference : yourMap.zoom - scaleDifference;
        this.editor.map.mapObject.setZoom(newZoom);
    }

}

export default MapSizeControl;